import { z } from "zod";
import { nullishToOptional } from "../../../helpers/nullish-to-optional";
import { FigmaComponentPropertyMap } from "../component-properties";

export const ComponentElementData = z.object({
  value: z.object({
    thumbnailImage: z.object({
      value: z.object({
        url: z.string(),
        assetId: z.string(),
      }),
    }),

    svg: z
      .object({
        value: z.object({
          url: z.string(),
          assetId: z.string(),
        }),
      })
      .optional(),

    parentComponentPersistentId: nullishToOptional(z.string()),
    componentPropertyDefinitions: nullishToOptional(FigmaComponentPropertyMap),
    variantPropertyValues: nullishToOptional(z.record(z.string())),
    renderNodeId: nullishToOptional(z.string()),
  }),
});

export type ComponentElementData = z.infer<typeof ComponentElementData>;
